import React from 'react';
import { Section } from './ui/Section';
import { Wind, ListTodo, CheckSquare } from 'lucide-react';
export function MechanismSection() {
  return <Section className="bg-[#0A0A0A] relative overflow-hidden" data-id="element-112">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[600px] bg-[#2563EB]/5 blur-[100px] rounded-full pointer-events-none" data-id="element-113" />

      <div className="text-center mb-16 relative z-10" data-id="element-114">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-115">
          El mecanismo RMF: <span className="text-[#2563EB]" data-id="element-116">R.O.C.</span>
        </h2>
        <p className="text-xl text-gray-400 font-mono" data-id="element-117">
          (Respira – Ordena – Cierra)
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto relative z-10" data-id="element-118">
        {/* R Card */}
        <div className="bg-[#111111] border border-gray-800 p-8 rounded-2xl hover:border-[#2563EB]/50 transition-all duration-300 group" data-id="element-119">
          <div className="flex justify-between items-start mb-6" data-id="element-120">
            <span className="text-6xl font-black text-[#2563EB]/20 group-hover:text-[#2563EB] transition-colors" data-id="element-121">
              R
            </span>
            <div className="bg-[#1A1A1A] px-3 py-1 rounded text-xs font-mono text-[#2563EB]" data-id="element-122">
              2:00
            </div>
          </div>
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-123">Respira</h3>
          <div className="w-12 h-1 bg-[#2563EB] mb-6" data-id="element-124" />
          <p className="text-gray-400 leading-relaxed" data-id="element-125">
            Bajas la activación con técnicas discretas (sin show, sin incienso).
          </p>
          <Wind className="w-8 h-8 text-[#2563EB]/40 mt-8 ml-auto" data-id="element-126" />
        </div>

        {/* O Card */}
        <div className="bg-[#111111] border border-gray-800 p-8 rounded-2xl hover:border-[#2563EB]/50 transition-all duration-300 group" data-id="element-127">
          <div className="flex justify-between items-start mb-6" data-id="element-128">
            <span className="text-6xl font-black text-[#2563EB]/20 group-hover:text-[#2563EB] transition-colors" data-id="element-129">
              O
            </span>
            <div className="bg-[#1A1A1A] px-3 py-1 rounded text-xs font-mono text-[#2563EB]" data-id="element-130">
              1:30
            </div>
          </div>
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-131">Ordena</h3>
          <div className="w-12 h-1 bg-[#2563EB] mb-6" data-id="element-132" />
          <p className="text-gray-400 leading-relaxed" data-id="element-133">
            Haces triage brutal para recuperar control: ahora / después / no
            hoy.
          </p>
          <ListTodo className="w-8 h-8 text-[#2563EB]/40 mt-8 ml-auto" data-id="element-134" />
        </div>

        {/* C Card */}
        <div className="bg-[#111111] border border-gray-800 p-8 rounded-2xl hover:border-[#2563EB]/50 transition-all duration-300 group ring-1 ring-[#2563EB]/20" data-id="element-135">
          <div className="flex justify-between items-start mb-6" data-id="element-136">
            <span className="text-6xl font-black text-[#2563EB] group-hover:text-[#2563EB] transition-colors" data-id="element-137">
              C
            </span>
            <div className="bg-[#1A1A1A] px-3 py-1 rounded text-xs font-mono text-[#2563EB]" data-id="element-138">
              3:30
            </div>
          </div>
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-139">Cierra</h3>
          <div className="w-12 h-1 bg-[#2563EB] mb-6" data-id="element-140" />
          <p className="text-gray-400 mb-4" data-id="element-141">Cierre mínimo operativo:</p>
          <ul className="space-y-2 text-sm text-gray-300" data-id="element-142">
            <li className="flex items-center gap-2" data-id="element-143">
              <div className="w-1.5 h-1.5 bg-[#2563EB] rounded-full" data-id="element-144" /> 1
              siguiente acción
            </li>
            <li className="flex items-center gap-2" data-id="element-145">
              <div className="w-1.5 h-1.5 bg-[#2563EB] rounded-full" data-id="element-146" /> 1 límite
              (boundary)
            </li>
            <li className="flex items-center gap-2" data-id="element-147">
              <div className="w-1.5 h-1.5 bg-[#2563EB] rounded-full" data-id="element-148" /> 1
              mensaje plantilla
            </li>
          </ul>
          <CheckSquare className="w-8 h-8 text-[#2563EB] mt-6 ml-auto" data-id="element-149" />
        </div>
      </div>

      <div className="max-w-3xl mx-auto mt-16 bg-[#1A1A1A] border-l-4 border-[#2563EB] p-6 md:p-8 rounded-r-xl" data-id="element-150">
        <h4 className="text-xl font-bold text-white mb-3" data-id="element-151">
          Esto es lo que cambia todo:
        </h4>
        <p className="text-gray-300 text-lg" data-id="element-152">
          La mayoría “se calma” un poco… pero no cierra nada. Entonces el caos
          vuelve. <br data-id="element-153" />
          <span className="text-white font-bold" data-id="element-154">Aquí, cierras el loop.</span>
        </p>
      </div>
    </Section>;
}